module.exports = __webpack_public_path__ + "img/vital.9004b3ca.svg";